import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately when route changes
    // Using 'auto' for instant scroll (better for page navigation)
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;

